<template>
  <div>
    <component :is="component"></component>
  </div>
</template>

<script>
import PaymentMethods from './Main';
import PaymentMethodsForm from './Form';

export default {
  name: 'PaymentMethodsMain',

  data() {
    return {
      component: null,
    };
  },

  components: {
    PaymentMethods,
    PaymentMethodsForm,
  },

  methods: {
    checkPage(to) {
      if (to.params.page === 'edit' || to.params.page === 'create') {
        this.component = PaymentMethodsForm;
      } else {
        this.component = PaymentMethods;
      }
    },
  },

  beforeRouteUpdate(to, from, next) {
    this.checkPage(to);
    next();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.checkPage(to);
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/payment/methods/Index.vue